import { createContext, useContext, useState, useEffect } from "react";
import { supabase } from "../lib/supabaseClient";

const DisplayModeContext = createContext();

export function DisplayModeProvider({ children }) {
  const [mode, setMode] = useState("simple");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadDisplayMode();
  }, []);

  async function loadDisplayMode() {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;

      const { data } = await supabase
        .from("profiles")
        .select("display_mode")
        .eq("id", user.id)
        .single();

      if (data?.display_mode) {
        setMode(data.display_mode);
      }
    } catch (error) {
      console.error("DisplayMode Load Error:", error);
    } finally {
      setLoading(false);
    }
  }

  async function updateMode(newMode) {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;

      await supabase
        .from("profiles")
        .update({ display_mode: newMode })
        .eq("id", user.id);

      setMode(newMode);
    } catch (error) {
      console.error("DisplayMode Update Error:", error);
    }
  }

  return (
    <DisplayModeContext.Provider value={{ mode, updateMode, loading }}>
      {children}
    </DisplayModeContext.Provider>
  );
}

export function useDisplayMode() {
  return useContext(DisplayModeContext);
}
